export default {
  buttons: {
    start: 'Commencer la préparation de la commande programmée',
  },
};
